import React from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from 'bonfire-kindling';

import { Page } from 'components';
import { useFeatureFlags } from 'helpers/hooks';

const TemporaryRootRedirect = () => {
  const { t } = useTranslation();
  const { isFlagEnabled, isLoading } = useFeatureFlags();

  if (isLoading) {
    return (
      <Page isTinted sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress aria-label={t('components.loading_icon')} />
      </Page>
    );
  }

  if (isFlagEnabled('FF_16_RELEASE_TOGGLE_PV_VENDOR_DASHBOARD')) {
    return <Redirect to="/dashboard" />;
  }

  return <Redirect to="/opportunities" />;
};

export default TemporaryRootRedirect;
